<template>
  <fts-profile
    :user-name="notification.audit && notification.audit.updatedBy"
    :profile-photo-size="40"
    profile-name-class="notification-content-details"
    class="fts-notification-content notification-content"
    :class="{'notification-content--read': notification.read}"
    :key="notification.id"
    @click.native="select"
  >
    <div
      slot="profileName"
      slot-scope="{ userProfileName }"
    >
      <span class="fts-text-primary">{{ userProfileName }}</span>
      <span v-html="notification.shortMessage"></span>
       <fts-moji
        :size="15"
        :emoji="moduleData.emoji"
        class="notification-content-emoji"
      />
      <span>{{ moduleData.name }}</span>
      <fts-tippy
        :content="
          moment(notification.audit.updatedDate).format('llll')
        "
        :options="{
          arrow: false,
          placement: 'right',
        }"
        trigger-class="notification-content-date"
      >
        <template #trigger>
          {{ momentRelativeTime(notification.audit.updatedDate) }}
        </template>
      </fts-tippy>
      <div
        class="notification-content-unread"
        v-if="!notification.read"
      />
    </div>
  </fts-profile>
</template>

<script>
import moment from "moment";

import FTSProfile from "../FTSProfile";
import FTSMoji from "../FTSMoji";
import FTSTippy from "../FTSTippy";
import { clientStore } from '../../store/clientStore';
import commons from '../../commons/commons';

export default {
  components: {
    "fts-profile": FTSProfile,
    "fts-moji": FTSMoji,
    "fts-tippy": FTSTippy,
  },
  props: {
    notification: Object,
  },
  methods: {
    moment,
    momentRelativeTime(date) {
      return commons.momentRelativeTime(date);
    },
    select() {
      this.$emit('select', this.notification);
    },
  },
  computed: {
    moduleData() {
      const module = (clientStore.state.workspaceModules || []).find(
        x => x.id == this.notification.vectorId
      ) || {};
      
      return {
        id: module.id,
        name: module.name,
        emoji: module.emoji,
      };
    },
  },
}
</script>